import React, {useEffect} from "react"
// MUI
import {Box, Stack, Switch, TextField, Typography} from "@mui/material"
// UI
import {BrandMultipleSelect} from "@/components/UI"
// Data
import {useData} from "@/context/PackagingDataProvider"
// Tokens
import {packagingTokens as tk} from "@/theme/packagingTokens"

// General settings: optional name, geo-IP fallback behaviour, served brands.
export default function AppEditorGeneralSection(props: any) {

    const {app, setApp, t} = props
    const {brands, getBrands} = useData()

    useEffect(() => {
        if (!brands) getBrands()
    }, [brands, getBrands])

    return (
        <Stack spacing={2.5}>
            <TextField
                label={t("app_name")}
                placeholder={t("app_name_placeholder")}
                value={app.name ?? ""}
                onChange={(e) => setApp({...app, name: e.target.value})}
                fullWidth
                size={"small"}
            />

            {/* Geo-IP fallback — switch row with explanation */}
            <Box
                onClick={() => setApp({...app, geo_ip_fallback: !app.geo_ip_fallback})}
                sx={{
                    display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2,
                    px: 1.75, py: 1.25,
                    border: `1px solid ${tk.color.borderLight}`,
                    borderRadius: tk.radius.card,
                    cursor: "pointer",
                    "&:hover": {backgroundColor: tk.color.bg},
                }}
            >
                <Box>
                    <Typography sx={{fontSize: "13.5px", fontWeight: 600, color: tk.color.textPrimary}}>
                        {t("geo_ip_fallback_label")}
                    </Typography>
                    <Typography sx={{fontSize: "12.5px", color: tk.color.textSecondary, mt: 0.25}}>
                        {t("geo_ip_fallback_hint")}
                    </Typography>
                </Box>
                <Switch
                    checked={Boolean(app.geo_ip_fallback)}
                    onChange={() => setApp({...app, geo_ip_fallback: !app.geo_ip_fallback})}
                    onClick={(e) => e.stopPropagation()}
                    inputProps={{"aria-label": t("geo_ip_fallback_label")}}
                />
            </Box>

            <BrandMultipleSelect {...{app, setApp, brands, t}} />
        </Stack>
    )
}
